module.exports = __webpack_public_path__ + "static/ap-a3046cb2811562026452bcf8581a9ac3.jpg";